var Logical;
(function (Logical) {
    Logical["AND"] = "AND";
    Logical["OR"] = "OR";
})(Logical || (Logical = {}));
var OAuthGrantType;
(function (OAuthGrantType) {
    OAuthGrantType["AUTHORIZATION_CODE"] = "authorization_code";
    OAuthGrantType["MULTI_FACTOR_AUTHENTICATION"] = "mfa";
    OAuthGrantType["PASSWORD"] = "password";
    OAuthGrantType["REFRESH_TOKEN"] = "refresh_token";
})(OAuthGrantType || (OAuthGrantType = {}));
const ACCESS_TOKEN = 'access_token';
const CLIENT_ID = 'client_id';
const GRANT_TYPE = 'grant_type';
const MULTI_FACTOR_CODE = 'mfa_code';
const MULTI_FACTOR_TOKEN = 'mfa_token';
const REFRESH_TOKEN = 'refresh_token';
const TOKEN_TYPE = 'token_type';
const MULTI_FACTOR_ROLE = 'pre_auth';
const MULTI_FACTOR_TOKEN_TYPE = 'PRE_AUTH';
export { ACCESS_TOKEN, CLIENT_ID, GRANT_TYPE, Logical, MULTI_FACTOR_CODE, MULTI_FACTOR_ROLE, MULTI_FACTOR_TOKEN, MULTI_FACTOR_TOKEN_TYPE, OAuthGrantType, REFRESH_TOKEN, TOKEN_TYPE, };
//# sourceMappingURL=authentication-service-constants.js.map